import { EditOutlined } from '@material-ui/icons'

export default EditOutlined
